import { Radio, Button } from '@material-ui/core'
import React from 'react'
import { injectIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import 'styles/app/apps/user-assign.scss'
import translate from './translate'

const useStyles = makeStyles({
  radio: {
    '&.MuiRadio-colorSecondary.Mui-checked': {
      color: '#7353CC',
    },
  },
})

function AssignUsersForm({
  intl: { formatMessage },
  isBulkSelect,
  setIsBulkSelect,
  setIsBulkSelectOpen,
  setIsUserTableOpen,
}) {
  const classes = useStyles()

  return (
    <div className="user-assign">
      <div className="radio-group">
        <div // eslint-disable-line jsx-a11y/no-static-element-interactions
          className="radio-input"
          onClick={() => {
            setIsBulkSelect(false)
            setIsBulkSelectOpen(false)
          }}>
          <Radio
            className={classes.radio}
            href={null}
            checked={!isBulkSelect}
          />
          {formatMessage(translate.individualSiteAssigment)}
        </div>
      </div>
      <div className="button-wrap">
        <Button
          onClick={() => setIsUserTableOpen(true)}
          className="button-assignee">
          Assignee
        </Button>
      </div>
    </div>
  )
}

export default injectIntl(AssignUsersForm)
